/*
 * Pipeline Theme — custom.js
 * Moismont — Produit cadeau automatique
 */

(function() {

  // ─── CONFIGURATION ──────────────────────────────────────────
  const GIFT = {
    variantId:       123456789,
    threshold:       150 * 100,      // seuil en centimes
    bannerMessage:  'VOTRE CADEAU OFFERT !',
    progressMessage:'Plus que {amount} EUR pour votre cadeau !',
    priceLabel:     'OFFERT'
  };
  // ────────────────────────────────────────────────────────────

  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT.variantId,
        quantity: 1,
        properties: { _gift: 'true' }
      })
    });
  }

  async function removeGift(key) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: 0 } })
    });
  }

  function getGiftItem(cart) {
    return cart.items.find(i =>
      String(i.variant_id) === String(GIFT.variantId) &&
      i.properties && i.properties._gift === 'true'
    );
  }

  function getNonGiftTotal(cart) {
    return cart.items
      .filter(i => !(i.properties && i.properties._gift === 'true'))
      .reduce((sum, i) => sum + i.final_line_price, 0);
  }

  function formatAmount(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateUI(unlocked, remaining, total) {
    const banner   = document.getElementById('cart-gift-banner');
    const progress = document.getElementById('cart-gift-progress');
    const bar      = document.getElementById('cart-gift-bar');

    if (banner)   banner.style.display   = unlocked ? 'block' : 'none';
    if (progress) {
      progress.style.display = unlocked ? 'none' : 'block';
      const msg = GIFT.progressMessage.replace('{amount}', formatAmount(remaining));
      const txt = progress.querySelector('#cart-gift-progress-text');
      if (txt) txt.textContent = msg;
    }
    if (bar) {
      const pct = Math.min(100, Math.round((total / GIFT.threshold) * 100));
      bar.style.width = pct + '%';
    }
  }

  async function syncGift() {
    const cart      = await fetchCart();
    const gift      = getGiftItem(cart);
    const total     = getNonGiftTotal(cart);
    const remaining = Math.max(0, GIFT.threshold - total);
    const unlocked  = total >= GIFT.threshold;

    if (unlocked && !gift) {
      await addGift();
      // Demande au thème Pipeline de rafraîchir le panier
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      return;
    }
    if (!unlocked && gift) {
      await removeGift(gift.key);
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      return;
    }
    updateUI(unlocked, remaining, total);
  }

  // Écoute les événements natifs du thème Pipeline
  document.addEventListener('theme:cart:change', function(event) {
    syncGift();
  });
  document.addEventListener('theme:cart:init', function() {
    syncGift();
  });
  document.addEventListener('DOMContentLoaded', syncGift);

  // Bloque la suppression manuelle du cadeau par le client
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-item-remove], .cart__remove, [data-remove]');
    if (!btn) return;
    const cart = await fetchCart();
    const gift = getGiftItem(cart);
    if (!gift) return;
    const key = btn.dataset.cartItemRemove || btn.dataset.key || btn.dataset.remove;
    if (key === gift.key) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

})();